<template>
    <v-layout :class="layout">
        <v-flex :class="flex">
            <v-img :src="src" :min-height="_minHeight" :max-height="maxHeight" :contain="!!maxHeight" :class="imgClass">
                <template v-slot:placeholder>
                    <v-layout fill-height align-center justify-center ma-0 class="grey lighten-3" v-if="flash || !src">
                        <slot>
                            <div>
                                <div class="text-xs-center">
                                    <v-icon large>insert_photo</v-icon>
                                </div>
                                <div class="text-xs-center grey--text text--darken-1 caption">{{ alt }}</div>
                            </div>
                        </slot>
                    </v-layout>
                </template>
            </v-img>
        </v-flex>
    </v-layout>
</template>

<script>
const DEFAULT_MIN_HEIGHT = 100;

export default {
    props: {
        layout: {
            type: String,
            default: 'align-center justify-center mb-3'
        },
        flex: {
            type: String,
            default: 'xs4'
        },
        imgClass: {
            type: String,
            default: ''
        },
        minHeight: {
            type: Number,
            default: 0
        },
        maxHeight: {
            type: Number
        },
        flash: {
            type: Boolean,
            default: false
        },
        alt: {
            type: String,
            default: ''
        },
        src: {
            type: String,
            default: ''
        }
    },
    computed: {
        _minHeight() {
            return this.minHeight ? this.minHeight : this.src ? 0 : DEFAULT_MIN_HEIGHT;
        }
    }
};
</script>

<style scoped>
.shine {
}

.shine:after {
    animation: shine 5s ease-in-out infinite;
    animation-fill-mode: forwards;
    content: '';
    position: absolute;
    top: -110%;
    left: -210%;
    width: 200%;
    height: 200%;
    opacity: 0;
    transform: rotate(30deg);

    background: rgba(255, 255, 255, 0.13);
    background: linear-gradient(
        to right,
        rgba(255, 255, 255, 0.13) 0%,
        rgba(255, 255, 255, 0.13) 77%,
        rgba(255, 255, 255, 0.5) 92%,
        rgba(255, 255, 255, 0) 100%
    );
}

.shine:active:after {
    opacity: 0;
}

@keyframes shine {
    10% {
        opacity: 1;
        top: -30%;
        left: -30%;
        transition-property: left, top, opacity;
        transition-duration: 0.7s, 0.7s, 0.15s;
        transition-timing-function: ease;
    }
    100% {
        opacity: 0;
        top: -30%;
        left: -30%;
        transition-property: left, top, opacity;
    }
}
</style>
